import type { IDropdownProps } from './Dropdown'
import type { DropdownRowGap } from './Dropdown.h'

import { styled } from '@linaria/react'
import { COLOR, FIXED_INDENTS } from 'vars/index'
import { DropdownAlignment } from './Dropdown.h'

export const DropdownStyled = styled.div`
  display: inline-block;
  position: relative;
`

export const DropdownBody = styled.div<{
  isOpened: boolean
  alignment: IDropdownProps['alignment']
  rowGap?: DropdownRowGap
}>`
  display: ${({ isOpened }) => (isOpened ? 'flex' : 'none')};
  justify-content: flex-end;
  padding-top: ${({ rowGap }) =>
    `var(${rowGap?.[0] || FIXED_INDENTS.INDENT_0})`};
  position: absolute;
  right: ${({ alignment }) =>
    alignment === DropdownAlignment.Right ? 0 : 'auto'};
  left: ${({ alignment }) =>
    alignment === DropdownAlignment.Left ? 0 : 'auto'};
  z-index: 4;

  &::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: var(${COLOR.SURFACE_OPACITY_LIGHT_10});
    border-radius: 2px;
    cursor: pointer;
  }
`
